export function isURL(value: string): boolean {
	return (/^(http|HTTP|data|DATA)/u).test(value);
}
